/**
 * Created by User on 29-Jul-17.
 */
import React from 'react';

import {FormGroup,ControlLabel,FormControl} from 'react-bootstrap';

const FieldGroup = ({ label, type='text', name, placeholder, ...props }) =>  {
    return (
        <FormGroup>
            {label && <ControlLabel>{label}</ControlLabel>}

            <FormControl type={type} name={name} placeholder={placeholder} {...props} />
        </FormGroup>
    );
}

export default FieldGroup;



// WEBPACK FOOTER //
// ./src/components/FieldGroup/index.js